import React, { useCallback } from 'react';
import { List } from 'react-window';

function Row({ index, style, items, renderRow }) {
  return renderRow(items[index], index, style);
}

/**
 * Thin wrapper around react-window's <List> so feature components only
 * need to supply data + a row renderer instead of repeating react-window
 * boilerplate. Give the wrapping element a fixed/flex height via `style`
 * or `className` — List fills whatever height it's given.
 */
export default function VirtualizedList({
  items,
  itemKey,
  rowHeight,
  renderRow,
  listRef,
  className,
  style,
  overscanCount = 4,
}) {
  const rowKey = useCallback(
    (index, data) => itemKey(data.items[index], index),
    [itemKey]
  );

  return (
    <List
      listRef={listRef}
      rowComponent={Row}
      rowCount={items.length}
      rowHeight={rowHeight}
      rowProps={{ items, renderRow }}
      rowKey={itemKey ? rowKey : undefined}
      overscanCount={overscanCount}
      className={className}
      style={style}
    />
  );
}
